import React, { CSSProperties } from 'react';

/**
 * {@docCategory TemplatePanel}
 */
export interface TemplateAreaProps {
   /**
    * The area where the item is placed.
    */
   areaName: string;

   /**
    * The justify setting for the area.
    *
    * @defaultvalue start
    */
   justify?: 'start' | 'end' | 'center' | 'stretch';

   /**
    * The align setting for the area.
    *
    * @defaultvalue start
    */
   align?: 'start' | 'end' | 'center' | 'stretch';

   /**
    * Sets a className on the area.
    */
   className?: string;

   /**
    * Sets styles on the area.
    */
   style?: CSSProperties;
}

/**
 * {@docCategory TemplatePanel}
 */
export const TemplateArea = (props: React.PropsWithChildren<TemplateAreaProps>) => {
   return (
      <div data-area-name={props.areaName} style={props.style}
           className={props.className}>{props.children}</div>
   );
};

